import $ from 'jquery'
import Clipboard from 'clipboard'
import {toRMBYuan} from '../filters'
import { copyRequest } from '@/utils/request'
import { sdSign } from '@/utils/crypto'
import _app from '../main'

export function getVersion() {
  const versionMsg = { os: '', version: '', isWeixin: false };
  const ua = navigator.userAgent;
  versionMsg.isWeixin = (!!ua.toLowerCase().match(/MicroMessenger/i))
  const uaArr = ua.split(" ");
  let matchItem = '';
  for (let i = 0; i < uaArr.length; i++) {
    if ((/UserVersion/i).test(uaArr[i])) {
      matchItem = uaArr[i];
      break;
    }
  }
  if (matchItem) {
    const versionArr = matchItem.split('_');
    versionMsg.os = versionArr[1];
    versionMsg.version = versionArr[2]
  }
  return versionMsg;
}

export function getCookie(name) {
  const arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
  if (arr != null) return unescape(arr[2]);
  return undefined;
}

export function formatDate (date, fmt) {
  date = new Date(date)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }

  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }

  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, str.padStart(2, '0'))
    }
  }
  return fmt;
}

export function compareVersion (v1, v2) {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }

  return 0;
}

export function renderRuleText (key, value) {
  switch (key) {
    case 'register':
      return getDate(value.day) + '后注册的用户';
    case 'invite':
      return value.day + '天内邀请下级人数大于等于' + value.num + '人';
    case 'order':
      return value.day + '天内个人订单大于' + value.num + '单(取消无效)';
    case 'effect':
      return value.day + '天内效果预估大于' + toRMBYuan(value.num) + '元';
    case 'bigAmount':
      return '巨额补贴活动只能参与' + value.num + '次';
    default:
      return ''
  }
}

export function getDate (num) {
  const now = new Date().getTime()
  const date = new Date(now - num * 24 * 60 * 60 * 1000)
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate()
  return year + '年' + month + '月' + day + '日'
}

export function getShowTime (time) {
  let timeCountDown, timeShow;
  timeCountDown = ((new Date()).getTime() - time) / 1000;
  if (timeCountDown < 60) {
    timeShow = '刚刚';
  } else if (timeCountDown >= 60 && timeCountDown < 3600) {
    timeCountDown = Math.floor(timeCountDown / 60);
    timeShow = `${timeCountDown}分钟前`;
  } else if (timeCountDown >= 3600 && timeCountDown < 86400) {
    timeCountDown = Math.floor(timeCountDown / 60 / 60);
    timeShow = `${timeCountDown}小时前`;
  } else if (timeCountDown >= 86400 && timeCountDown < 172800) {
    timeShow = `昨天`;
  }  else if (timeCountDown >= 172800 && timeCountDown < 604800) {
    timeCountDown = Math.floor(timeCountDown / 60 / 60 / 24);
    timeShow = `${timeCountDown}天前`;
  } else {
    const dates = new Date(time);
    const year = dates.getFullYear();
    const month = dates.getMonth() + 1;
    const date = dates.getDate();
    timeShow = `${year}年${month}月${date}日`;
  }
  return timeShow;
}

export function asyncCopy (
  {
    el,
    url,
    data,
    copySucText = '复制成功，请打开手淘!',
    copyErrText = '复制失败，请长按复制',
    copySucCallback,
    copyErrCallback
  }) {
  copyRequest({
    url,
    data,
    callback: (res) => {
      $(el).data('pwd', res.data.pwd || res.data.taokePwd);
    }
  })

  const clipboard = new Clipboard(el, {
    text: () => $(el).data('pwd')
  });
  clipboard.on('success', (e) => {
    if (copySucCallback) {
      if (e && e.text) {
        copySucCallback(e.text)
      }
    } else {
      _app.$toast.show(copySucText)
    }
  })
  clipboard.on('error', (e) => {
    if (copyErrCallback) {
      if (e && e.text) {
        copyErrCallback(e.text)
      }
    } else {
      _app.$toast.show(copyErrText)
    }
  })
}

export function generateSdParams (token, pid, relationId) {
  const params = {
    token,
    pid,
    timestamp: (new Date).getTime()
  }
  if (relationId) {
    params.relationId = relationId
  }
  const secret = 'ua099Kid9)djfuv9123'
  const sign = sdSign(secret, params)
  return {
    ...params,
    sign
  }
}

export function generateSdParams2 (item, pid, relationId) {
  const params = {
    itemId: item.itemId,
    title: item.title,
    pictUrl: item.pictUrl,
    pid,
    timestamp: (new Date).getTime()
  }
  if (item.activityId) {
    params.activityId = item.activityId
  }
  if (relationId) {
    params.relationId = relationId
  }
  const secret = 'ua099Kid9)djfuv9123'
  const sign = sdSign(secret, params)
  return {
    ...params,
    sign
  }
}

export function convertFen2Yuan (price) {
  return (price/100).toFixed(2);
}
